import styled from "@emotion/styled";
import { WidthDefinedButtonList } from "../ButtonList";

export const EventFlowerStandButtonList = styled(WidthDefinedButtonList)`
  width: 90%;
  margin: 0 auto;
`;

EventFlowerStandButtonList.displayName = "EventFlowerStandButtonList";
